export function PageHero({ kicker, title, text }: { kicker?: string; title: string; text: string }) {
  return (
    <section className="bg-navy text-white">
      <div className="container py-16">
        {kicker ? <span className="badge badge--primary mb-5">{kicker}</span> : null}
        <h1 className="max-w-4xl text-4xl font-black leading-tight md:text-6xl">{title}</h1>
        <p className="mt-5 max-w-3xl text-lg leading-8 text-slate-300">{text}</p>
      </div>
    </section>
  );
}
